<template>
  <div
    class="bbp-time-history-modal"
    :style="position"
  >
    Are you sure you want to transfer the comment to {{ date }} ?
    <div class="bbp-time-history-modal-bottom">
        <button
          class="bbp-button bbp-time-history-modal-bottom__button"
          @click="onButtonYes"
        >
          Yes
        </button>
        <button
          class="bbp-button bbp-time-history-modal-bottom__button"
          @click="onClose"
        >
          No
        </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BBPTimeHistoryModal',
  props: {
    position: {
      type: Object,
      default: () => ({})
    },
    currentItem: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    date () {
      const { startDate } = this.currentItem
      return moment(startDate).format('MMMM DD, YYYY')
    }
  },
  methods: {
    onClose () {
      this.$emit('update:isShowModal', false)
    },
    onButtonYes () {
      this.$emit('onButtonYes')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-time-history-modal {
    position: fixed;
    width: 274px;
    height: 137px;
    padding: 44px 12px 20px 12px;
    border-radius: 5px;
    background: $color-white;
    box-shadow: 0 0 20px rgba($color-black, 0.05);
    text-align: center;
    font-weight: 400;
    line-height: 17px;
    font-size: 14px;
  }

  .bbp-time-history-modal-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    grid-gap: 0 10px;
    margin: 13px 0 0 0;

    &__button {
      width: 40px;
      height: 26px;
      padding: 0;
      font-weight: 400;
      line-height: 14px;
      font-size: 12px;
      text-transform: capitalize;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistoryModal.vue